module.exports = __webpack_public_path__ + "img/icon-pack-magento-10.56146b17.svg";